import CreatePaymentRefundItem from '../../../Domain/CreatePaymentRefundItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import ClientPaymentService from '../../../Services/ClientPaymentService';

export default class CreateClientPaymentRefundWindowDescription {
  static titleForCreate = 'Add New Client Payment Refund';
  static itemType = CreatePaymentRefundItem;
  static serviceFunction = (edited) => ClientPaymentService.CreateClientPaymentRefund(edited, null, false, null);

  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: (item) => CreateClientPaymentRefundWindowDescription.getPaymentId(item),
          label: 'Client Payment',
          className: 'col-6',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => item.isFromClient,
        },
        {
          fieldName: 'RefundedOn',
          label: 'Refund Transaction Date',
          className: 'col-6',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'ReasonCode',
          label: 'Refund Reason',
          className: 'col-6',
          type: InputTypesEnum.ClientPaymentRefundReasonSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'MethodCode',
          label: 'Refund Transaction Method',
          className: 'col-6',
          type: InputTypesEnum.ClientPaymentRefundMethodSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'Amount',
          label: 'Amount',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
        },
        {
          fieldName: 'TransactionReference',
          label: 'Transaction Reference',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: (e, item) => ValidityHelper.forRequiredAndMaxLengthField(e, 100),
        },
        {
          fieldName: 'Comment',
          label: 'Comment',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: (e, item) => ValidityHelper.forRequiredAndMaxLengthField(e, 500),
        },
      ],
    },
  ];

  static getPaymentId(item) {
    return item.ClientPaymentId;
  }
}
